import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04376536"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "lg:container lg:flex lg:mx-auto" }
const _hoisted_3 = { class: "lg:w-1/3" }
const _hoisted_4 = {
  key: 1,
  class: "overview-item flex flex-col-reverse md:flex-row lg:flex-col-reverse lg:mt-8 bg-white lg-boxed-container z-50 top-0 lg:top-4",
  style: {"margin-right":"0"}
}
const _hoisted_5 = {
  class: "flex-1 p-4 md:p-8 lg:p-4",
  "data-cy": "immobilie-stammdaten"
}
const _hoisted_6 = { class: "text-lg" }
const _hoisted_7 = { class: "text-lg mb-4" }
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col items-end justify-end gap-2"
}
const _hoisted_9 = { class: "mt-4 mb-0" }
const _hoisted_10 = {
  class: "w-auto md:w-auto",
  style: {"min-width":"300px"}
}
const _hoisted_11 = { class: "relative lg:w-auto h-48 md:h-96 md:m-4" }
const _hoisted_12 = { class: "absolute bottom-0 left-0 right-0 grid justify-items-end" }
const _hoisted_13 = {
  id: "media-box",
  class: "lg:w-2/3"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-8 boxed-container"
}
const _hoisted_15 = { class: "flex items-center px-4 mt-4" }
const _hoisted_16 = { class: "my-0 mb-2 flex-1" }
const _hoisted_17 = {
  key: 1,
  class: "mt-8 boxed-container"
}
const _hoisted_18 = { class: "flex items-center px-4 mt-4" }
const _hoisted_19 = { class: "my-0 mb-2 flex-1" }
const _hoisted_20 = {
  class: "p-3",
  style: {"height":"500px"}
}
const _hoisted_21 = {
  key: 2,
  class: "mt-8 boxed-container",
  "data-cy": "immobilie-video"
}
const _hoisted_22 = { class: "flex items-center px-4 mt-4" }
const _hoisted_23 = { class: "my-0 mb-2 flex-1" }
const _hoisted_24 = { style: {"position":"relative","padding-top":"58.25%"} }
const _hoisted_25 = { class: "p-3 iframe-video" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 3,
  class: "mt-8 boxed-container"
}
const _hoisted_28 = {
  class: "flex items-center px-4 mt-4",
  "data-cy": "immobilie-3dAufnahmen"
}
const _hoisted_29 = { class: "my-0 flex-1" }
const _hoisted_30 = {
  key: 0,
  style: {"position":"relative","padding-top":"58.25%"}
}
const _hoisted_31 = {
  key: 1,
  class: "bg-white"
}
const _hoisted_32 = {
  key: 4,
  class: "mt-8 boxed-container",
  "data-cy": "immobilie-drohnenAufnahmen"
}
const _hoisted_33 = { class: "flex items-center px-4 mt-4" }
const _hoisted_34 = { class: "my-0 mb-0 flex-1" }
const _hoisted_35 = { class: "bg-white" }
const _hoisted_36 = {
  key: 5,
  class: "mt-8 boxed-container",
  "data-cy": "immobilie-grundrisse"
}
const _hoisted_37 = { class: "flex items-center px-4 mt-4" }
const _hoisted_38 = { class: "my-0 flex-1" }
const _hoisted_39 = { class: "bg-white" }
const _hoisted_40 = ["data-cy"]
const _hoisted_41 = { class: "flex pb-2 items-center" }
const _hoisted_42 = { class: "flex-1 pl-4 text-2xl md:text-3xl smaller-header-margin" }
const _hoisted_43 = { key: 6 }
const _hoisted_44 = { class: "flex pb-2 items-center" }
const _hoisted_45 = { class: "flex-1 pl-4 text-2xl md:text-3xl smaller-header-margin" }
const _hoisted_46 = { class: "flex justify-center" }
const _hoisted_47 = {
  key: 1,
  class: "boxed-container"
}
const _hoisted_48 = { class: "flex items-center" }
const _hoisted_49 = { class: "flex-1 pl-4 text-2xl md:text-3xl" }
const _hoisted_50 = {
  key: 7,
  class: "mt-8 boxed-container"
}
const _hoisted_51 = { class: "flex-1 pl-4 text-2xl md:text-3xl" }
const _hoisted_52 = { class: "grid grid-cols-1 auto-rows-fr lg:p-0 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1" }
const _hoisted_53 = {
  key: 0,
  class: "shadow-lg boxed-container"
}
const _hoisted_54 = {
  key: 8,
  class: "mt-8 boxed-container shadow-lg"
}
const _hoisted_55 = { class: "px-4 mt-4" }
const _hoisted_56 = { class: "my-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_PropertyActionButtons = _resolveComponent("PropertyActionButtons")!
  const _component_PropertyInfo = _resolveComponent("PropertyInfo")!
  const _component_InfoField = _resolveComponent("InfoField")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_ChatComponent = _resolveComponent("ChatComponent")!
  const _component_AppMap = _resolveComponent("AppMap")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_horizontal_item_scroll = _resolveComponent("horizontal-item-scroll")!
  const _component_AFlatButton = _resolveComponent("AFlatButton")!
  const _component_HzbaList = _resolveComponent("HzbaList")!
  const _component_CreateHzbaCard = _resolveComponent("CreateHzbaCard")!
  const _component_DocumentItem = _resolveComponent("DocumentItem")!
  const _component_DragAndDropDocument = _resolveComponent("DragAndDropDocument")!
  const _component_PropertyNotes = _resolveComponent("PropertyNotes")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.t(`${_ctx.organisationPrefix}toolbar.mobile.objectDetail`) + ' - ' + (_ctx.property?.externeObjektNr ?? 'loading...')
      }, _createSlots({ _: 2 }, [
        (!_ctx.isMobile)
          ? {
              name: "leading",
              fn: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      fill: "clear",
                      class: "px-0 -ml-4",
                      size: "small",
                      onClick: _cache[0] || (_cache[0] = () => _ctx.goBackFromPoperty())
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.arrowBack,
                          class: "ml-white-text",
                          size: "large"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : {
              name: "trailing",
              fn: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "end" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      fill: "clear",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.goBackFromPoperty())
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.closeOutline,
                          class: "ml-white-text",
                          size: "large",
                          title: _ctx.$t('immobilie.buttons.closeDetailPage')
                        }, null, 8, ["icon", "title"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              key: "1"
            }
      ]), 1032, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (!_ctx.property)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_skeleton)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["bg-gray-100", _ctx.isMobile ? '' : ' lg:mt-2 md:mt-8'])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_PropertyInfo, {
                          key: 0,
                          property: _ctx.property,
                          "can-access-photos": _ctx.canAccessPhotos,
                          onAddPreview: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addVorschaubild())),
                          onAddMorePhotos: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addImmoPhoto())),
                          onOpenGallery: _cache[8] || (_cache[8] = ($event: any) => ( _ctx.openBaseModal('gallery', {
                images: _ctx.propertyBilder,
                title: 'Fotos',
                allowAddMore: true,
                downloadEnabled: true,
                onDelete: _ctx.deleteImage,
                deleteLocally: true
              })))
                        }, {
                          fields: _withCtx(() => [
                            _createVNode(_component_PropertyActionButtons, {
                              property: _ctx.property,
                              "is-person-button-enabled": _ctx.featureFlags?.property?.changePerson,
                              "is-status-button-enabled": _ctx.featureFlags?.property?.changeStatus,
                              "is-share-button-enabled": _ctx.isNetworkConnected,
                              "is-locate-button-enabled": true,
                              onChangePerson: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePerson(_ctx.property, _ctx.t))),
                              onChangeStatus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStatus(_ctx.property, _ctx.t))),
                              onShare: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handlePropertyShare(_ctx.property.id.toString(), _ctx.t))),
                              onLocate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectToMap({ lon: _ctx.property.geolocationLon, lat: _ctx.property.geolocationLat })))
                            }, null, 8, ["property", "is-person-button-enabled", "is-status-button-enabled", "is-share-button-enabled"])
                          ]),
                          _: 1
                        }, 8, ["property", "can-access-photos"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_InfoField, {
                              title: _ctx.t(`${_ctx.organisationPrefix}immobilie.adresse`)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.property.strasse), 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.property.plz + " " + _ctx.property.stadt), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["title"]),
                            _createVNode(_component_InfoField, {
                              title: _ctx.t(`${_ctx.organisationPrefix}immobilie.vorhabentraeger`),
                              value: _ctx.t(`${_ctx.organisationPrefix}immobilie.vorhabentraegerValue`)
                            }, null, 8, ["title", "value"]),
                            _createVNode(_component_InfoField, {
                              title: _ctx.t('immobilie.eigentuemer'),
                              "separate-line": false,
                              value: _ctx.property.eigentuemer
                            }, null, 8, ["title", "value"]),
                            _createVNode(_component_InfoField, {
                              title: _ctx.t(`${_ctx.organisationPrefix}immobilie.objektnummer`),
                              value: _ctx.property.name
                            }, null, 8, ["title", "value"]),
                            (_ctx.featureFlags?.property?.changeStatus)
                              ? (_openBlock(), _createBlock(_component_InfoField, {
                                  key: 0,
                                  title: _ctx.t('immobilie.status'),
                                  value: _ctx.translatedPropertyStatus(_ctx.property.status, _ctx.t)
                                }, null, 8, ["title", "value"]))
                              : _createCommentVNode("", true),
                            (_ctx.featureFlags?.property?.changePerson)
                              ? (_openBlock(), _createBlock(_component_InfoField, {
                                  key: 1,
                                  title: _ctx.t('immobilie.person'),
                                  value: _ctx.property.verwalters?.map?.(item => item.username).join(', ')
                                }, null, 8, ["title", "value"]))
                              : _createCommentVNode("", true),
                            (_ctx.canCreateUpdateObject && (_ctx.featureFlags?.property?.changeStatus || _ctx.featureFlags?.property?.changePerson))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  (_ctx.featureFlags?.property?.changeStatus)
                                    ? (_openBlock(), _createBlock(_component_AButton, {
                                        key: 0,
                                        "btn-tertiary": true,
                                        "data-cy": "immobilie-status",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeStatus(_ctx.property, _ctx.t)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('immobilie.updateStatus')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.featureFlags?.property?.changePerson)
                                    ? (_openBlock(), _createBlock(_component_AButton, {
                                        key: 1,
                                        "btn-tertiary": true,
                                        "data-cy": "immobilie-person",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePerson(_ctx.property, _ctx.t)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('immobilie.updatePerson')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.featureFlags?.property?.editProperty)
                                    ? (_openBlock(), _createBlock(_component_AButton, {
                                        key: 2,
                                        "btn-tertiary": true,
                                        "data-cy": "immobilie-data",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openPropertyEditModal()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('immobilie.editProperty')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isNetworkConnected)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 3,
                                        class: "flex cursor-pointer",
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => ($event.stopPropagation(), _ctx.handlePropertyShare(_ctx.property.id.toString(), _ctx.t)))
                                      }, [
                                        _createVNode(_component_ion_icon, {
                                          size: "large",
                                          icon: _ctx.shareSocialOutline
                                        }, null, 8, ["icon"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedBaPool, (pool) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: pool.identifier
                                }, [
                                  (
                        pool.latestBericht &&
                        pool.identifier.indexOf('hzba') >= 0
                      )
                                    ? (_openBlock(), _createBlock(_component_AButton, {
                                        key: 0,
                                        "btn-primary": true,
                                        class: "mt-2",
                                        shape: "round",
                                        "data-cy": `button-bericht-${pool.identifier}-anzeigen`,
                                        onClick: ($event: any) => (
                        _ctx.openBaseModal('pdf.view', { pdf: pool.latestBericht })
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.berichtAnzeigen1") +
                          " " +
                          pool.titleBericht +
                          " " +
                          _ctx.t("immobilie.buttons.berichtAnzeigen2")), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data-cy", "onClick"]))
                                    : (pool.latestBericht)
                                      ? (_openBlock(), _createBlock(_component_AButton, {
                                          key: 1,
                                          "btn-primary": true,
                                          class: "mt-2",
                                          "data-cy": `button-bericht-${pool.identifier}-anzeigen`,
                                          onClick: ($event: any) => (
                        _ctx.openBaseModal('pdf.view', { pdf: pool.latestBericht })
                        )
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.berichtAnzeigen1") +
                          " " +
                          pool.titleBericht +
                          " " +
                          _ctx.t("immobilie.buttons.berichtAnzeigen2")), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["data-cy", "onClick"]))
                                      : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (
                      _ctx.property.anlageschema &&
                      _ctx.property.anlageschema.length > 0 &&
                      _ctx.property.anlageschema[0]
                    )
                                ? (_openBlock(), _createBlock(_component_AButton, {
                                    key: 0,
                                    "btn-primary": true,
                                    class: "mt-2",
                                    "data-cy": "button-anlagenschemaAnzeigen",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (
                      _ctx.openBaseModal('pdf.view', {
                        pdf: _ctx.property.anlageschema[0],
                      })
                      ))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.anlagenschemaAnzeigen")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (
                      _ctx.property.technikzentraleBericht &&
                      _ctx.property.technikzentraleBericht.length > 0 &&
                      _ctx.property.technikzentraleBericht[0]
                    )
                                ? (_openBlock(), _createBlock(_component_AButton, {
                                    key: 1,
                                    "btn-primary": true,
                                    "data-cy": "button-berichtTechnikzentraleAnzeigen",
                                    class: "mt-2",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (
                      _ctx.openBaseModal('pdf.view', {
                        pdf: _ctx.property.technikzentraleBericht[0],
                      })
                      ))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.berichtTechnikzentraleAnzeigen")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_a_image, {
                                "image-class": "object-cover h-full w-full -lg:m-4 md:rounded-lg",
                                "data-cy": "immobilie-vorschaubild",
                                src: _ctx.getPhotoUrl(_ctx.property?.vorschaubild)
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_12, [
                                (_ctx.canAccessPhotos && _ctx.property.vorschaubild)
                                  ? (_openBlock(), _createBlock(_component_AButton, {
                                      key: 0,
                                      type: 'submit',
                                      "btn-tertiary": true,
                                      "data-cy": "immobilie-vorschaubild",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addVorschaubild()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.vorschaubildAendern")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.canAccessPhotos && !_ctx.property.vorschaubild)
                                  ? (_openBlock(), _createBlock(_component_AButton, {
                                      key: 1,
                                      "btn-tertiary": true,
                                      "data-cy": "immobilie-vorschaubild-hinzufuegen",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addVorschaubild()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.vorschaubildHinzufuegen")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.canAccessPhotos)
                                  ? (_openBlock(), _createBlock(_component_AButton, {
                                      key: 2,
                                      "btn-tertiary": true,
                                      "data-cy": "immobilie-weitere-bilder-hinzufuegen",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addImmoPhoto()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.weitereFotoshinzufuegen")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.property?.bilder?.length > 0 || _ctx.property?.vorschaubild)
                                  ? (_openBlock(), _createBlock(_component_AButton, {
                                      key: 3,
                                      "btn-tertiary": true,
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (
                        _ctx.openBaseModal('gallery', {
                          images: _ctx.propertyBilder,
                          title: 'Fotos',
                          allowAddMore: true,
                          downloadEnabled: true,
                          onDelete: _ctx.deleteImage,
                          deleteLocally: true
                        })
                        ))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.weitereAnzeigen")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.featureFlags.chat && _ctx.immobilieLoaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.t('immobilie.communication')), 1)
                          ]),
                          _createVNode(_component_ChatComponent, {
                            width: "100%",
                            height: "500",
                            "rocket-chat-url": `https://movinglayers.echo-dc.eu/channel/${_ctx.chatChannelName}?layout=embedded`
                          }, null, 8, ["rocket-chat-url"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.featureFlags?.property?.map)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("h1", _hoisted_19, _toDisplayString(_ctx.t('immobilie.mapLabel')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_AppMap, {
                              style: {"height":"100%"},
                              identifier: 'propertyMap',
                              "map-settings": _ctx.mapConfig,
                              "property-location": { lat: _ctx.property.geolocationLat, lon: _ctx.property.geolocationLon }
                            }, null, 8, ["map-settings", "property-location"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.property.imageVideoLink)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.t("immobilie.video")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("iframe", {
                                style: {"border-radius":"20px"},
                                class: "p-3 iframe-video",
                                src: _ctx.property.imageVideoLink,
                                frameborder: "0",
                                allow: "autoplay; encrypted-media; fullscreen",
                                onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickedOnIframe && _ctx.clickedOnIframe(...args)), ["stop"]))
                              }, null, 8, _hoisted_26)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.featureFlags?.matterport &&
                (_ctx.property?.matterports?.length > 0) && (_ctx.property.matterportsAnzeigen !== false)
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h1", _hoisted_29, _toDisplayString(_ctx.t("immobilie.3dAufnahmen")), 1),
                            ((!_ctx.isMaxXSmall) && (_ctx.property?.matterports?.length > 1))
                              ? (_openBlock(), _createBlock(_component_IonButton, {
                                  key: 0,
                                  fill: "clear",
                                  class: "normal-case",
                                  "data-cy": "button-3dAufnahmen-anzeigen",
                                  onClick: _cache[20] || (_cache[20] = 
                    () =>
                      _ctx.openBaseModal('gallery.iframes', {
                        iframes: _ctx.property?.matterports,
                        title: '3D Aufnahmen',
                      })
                  )
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "end",
                                      icon: _ctx.chevronForwardOutline
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          ((_ctx.property.matterports.length === 1) && _ctx.isImmobilienverwalter())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_component_horizontal_item_scroll, {
                                  class: "p-3 iframe-video",
                                  "data-cy": "mappedMatterports",
                                  data: _ctx.mappedMatterports,
                                  "photo-mode": false,
                                  "show-only-one": (_ctx.property.matterports.length === 1),
                                  onOnIframeItemClicked: _cache[21] || (_cache[21] = 
                    (url) =>
                      _ctx.openBaseModal('gallery.iframe', {
                        iframe: url,
                        title: '3D Aufnahme',
                      })
                  )
                                }, null, 8, ["data", "show-only-one"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_horizontal_item_scroll, {
                                  "data-cy": "mappedMatterports",
                                  data: _ctx.mappedMatterports,
                                  "photo-mode": false,
                                  onOnIframeItemClicked: _cache[22] || (_cache[22] = 
                    (url) =>
                      _ctx.openBaseModal('gallery.iframe', {
                        iframe: url,
                        title: '3D Aufnahme',
                      })
                  )
                                }, null, 8, ["data"])
                              ])),
                          (_ctx.isMaxXSmall && _ctx.property.matterports?.length > 0)
                            ? (_openBlock(), _createBlock(_component_AFlatButton, {
                                key: 2,
                                expand: true,
                                class: "mb-4 mx-4",
                                onClick: _cache[23] || (_cache[23] = 
                  () =>
                    _ctx.openBaseModal('gallery.iframes', {
                      iframes: _ctx.property?.matterports,
                      title: '3D Aufnahmen',
                    })
                )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.property?.drohnenbilder?.length > 0) && (_ctx.property.drohnenbilderAnzeigen !== false))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("h1", _hoisted_34, _toDisplayString(_ctx.t("immobilie.drohnenAufnahmen")), 1),
                            (!_ctx.isMaxXSmall && _ctx.property.drohnenbilder?.length > 0)
                              ? (_openBlock(), _createBlock(_component_IonButton, {
                                  key: 0,
                                  fill: "clear",
                                  class: "normal-case",
                                  "data-cy": "button-drohnenAufnahmen-anzeigen",
                                  onClick: _cache[24] || (_cache[24] = 
                    () =>
                      _ctx.openBaseModal('gallery', {
                        images: _ctx.property?.drohnenbilder,
                        title: 'Drohnenbilder',
                        downloadEnabled: true,
                      })
                  )
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_horizontal_item_scroll, {
                              "data-cy": "drohnenbilder",
                              data: _ctx.mappedDrohnenbilder
                            }, null, 8, ["data"])
                          ]),
                          (_ctx.isMaxXSmall && _ctx.property.drohnenbilder?.length > 0)
                            ? (_openBlock(), _createBlock(_component_AFlatButton, {
                                key: 0,
                                expand: true,
                                class: "mb-4 mx-4",
                                onClick: _cache[25] || (_cache[25] = 
                  () =>
                    _ctx.openBaseModal('gallery', {
                      images: _ctx.property?.drohnenbilder,
                      title: 'Drohnenbilder',
                      downloadEnabled: true,
                    })
                )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.property?.grundrisss?.length > 0) && (_ctx.property.grundrissAnzeigen !== false))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("h1", _hoisted_38, _toDisplayString(_ctx.t("immobilie.grundrisse")), 1),
                            (!_ctx.isMaxXSmall && _ctx.property.grundrisss?.length > 0)
                              ? (_openBlock(), _createBlock(_component_IonButton, {
                                  key: 0,
                                  fill: "clear",
                                  class: "normal-case",
                                  "data-cy": "button-grundrisseAnzeigen",
                                  onClick: _cache[26] || (_cache[26] = 
                    () =>
                      _ctx.openBaseModal('gallery', {
                        images: _ctx.mappedGrundrissPhotos,
                        title: 'Grundrisse',
                        downloadEnabled: true,
                      })
                  )
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_horizontal_item_scroll, {
                              "data-cy": "mappedGrundrissData",
                              data: _ctx.mappedGrundrissData,
                              "photo-mode": false
                            }, null, 8, ["data"])
                          ]),
                          (_ctx.isMaxXSmall && _ctx.property.grundrisss?.length > 0)
                            ? (_openBlock(), _createBlock(_component_AFlatButton, {
                                key: 0,
                                expand: true,
                                class: "mb-4 mx-4",
                                onClick: _cache[27] || (_cache[27] = 
                  () =>
                    _ctx.openBaseModal('gallery', {
                      images: _ctx.mappedGrundrissPhotos,
                      title: 'Grundrisse',
                      downloadEnabled: true,
                    })
                )
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("immobilie.buttons.alleAnzeigen")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedBaPool, (groupedBas, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: groupedBas.identifier,
                        class: "mt-8 boxed-container-margin",
                        "data-cy": `immobilie-${groupedBas.identifier}`
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("h1", _hoisted_42, _toDisplayString(groupedBas.title), 1)
                        ]),
                        _createVNode(_component_HzbaList, {
                          class: _normalizeClass({ 'pb-4': index === _ctx.groupedBaPool.length - 1 }),
                          "data-cy": `list-${groupedBas.title}`,
                          hzbas: groupedBas.bas,
                          "has-report": true,
                          property: _ctx.property,
                          "template-identifier": groupedBas.identifier,
                          "property-view": ""
                        }, null, 8, ["class", "data-cy", "hzbas", "property", "template-identifier"])
                      ], 8, _hoisted_40))
                    }), 128)),
                    (_ctx.featureFlags?.createSurvey)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          (_ctx.isMobile)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["mb-6", { 'mt-4': _ctx.groupedBaPool.length === 0 }])
                              }, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("h1", _hoisted_45, _toDisplayString(_ctx.t('hzba.bestandsaufnahmen')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_AButton, {
                                    "btn-primary": true,
                                    class: "px-16 py-6 text-lg",
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.openAufnahmenModal()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('hzba.create')), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ], 2))
                            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("h1", _hoisted_49, _toDisplayString(_ctx.t('hzba.bestandsaufnahmen')), 1),
                                  _createVNode(_component_CreateHzbaCard, {
                                    "use-min-height": false,
                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.openAufnahmenModal()))
                                  })
                                ])
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.featureFlags?.property?.uploadDocument)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("h1", _hoisted_51, _toDisplayString(_ctx.t('immobilie.dokumente.dokumente')), 1),
                          _createElementVNode("div", _hoisted_52, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDokumentsUnsorted, (item, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "mt-8 boxed-container shadow-lg"
                              }, [
                                _createVNode(_component_DocumentItem, {
                                  document: item,
                                  onDelete: ($event: any) => (_ctx.deleteDocument(item.id))
                                }, null, 8, ["document", "onDelete"])
                              ]))
                            }), 128)),
                            (_ctx.canCreateUpdateObject)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createVNode(_component_DragAndDropDocument, {
                                    "property-id": _ctx.property.id,
                                    class: "h-full"
                                  }, null, 8, ["property-id"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.featureFlags?.property?.notes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("h1", _hoisted_56, _toDisplayString(_ctx.t('propertyNotes.title')), 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_PropertyNotes, {
                                "property-id": _ctx.property.id,
                                notes: _ctx.property.notes || []
                              }, null, 8, ["property-id", "notes"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}